import React, { useEffect, useMemo, useState } from "react";
import { Paper, Alert } from "@mui/material";
import { Box } from "@mui/system";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { display } from "../../redux/reducers/sidebar";
import { settingsClose } from "../../redux/reducers/companySkipSave";
import TotalAmountLabels from "./Components/TotalAmountLabels";
import EntryTable from "./Components/EntryTable";
import {
  showErrorSnackbar,
  showWarningSnackbar,
} from "../../components/snackBar/snakbar";
import { showSuccessSnackbar } from "../../components/snackBar/snakbar";
import PaymentDetails from "./Components/PaymentDetails";
import MultiFileAttachment from "./Components/MultiFileAttachment";
import Description from "./Components/Description";
import Grid from "@mui/material/Grid";
import {
  createInvoiceAttachmentArray,
  createInvoiceLineItemsArray,
  createInvoiceLineNonGST,
  createInvoiceLineNonItems,
  deleteTransactionDetails,
  deleteTransactionMaster,
  updateInvoiceTCSDetails,
  updatetransactionTimeStamp,
} from "../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import HsnandJournalTab from "./Components/HsnandJournalTab";
import {
  createInvoicePOSDetails,
  createPhoneContacts,
  createPOSParty,
  createSalesInvoice,
  createTransactionDetailsArray,
  createTransactionRelation,
  createTransactionWithSpecificTime,
  getInvoiceMaster,
  getInvoiceMasterCustom,
  listlatestInvoiceCustom,
} from "../../graphql";
import "./Components//Invoice.css";
import Loader from "./Components/Loader";
import { PosPrint } from "../../library/InvoicePrint";
import { useShare } from "../../components/modals/Share";
import printJS from "print-js";
import ConfirmCancel from "../../components/modals/confirmCancel";
import axios from "axios";
import PreviewSalesTaxable from "../../components/modals/PreviewSalesTaxable";
import { uploadToServer } from "../../library/upload";
import PromptInvoiceSettings from "../../components/modals/PromptInvoiceSettings";
import InvoicePosBasicDetails from "./Components/InvoicePosBasicDetails";
import ConfirmExit from "../../components/modals/ConfirmExit";
import DraggableAction from "../../components/Buttons/DraggableAction";
import InvoiceCancel from "../../components/modals/InvoiceCancel";
import useSaveShortcut from "../../hooks/useSaveShortcut";
import { setNavigationBlocked } from "../../redux/reducers/controllNavigation";
import { VoucherSettingsApi } from "../../redux/apis/newVoucherSettings.api";
import { useListInvoiceSettingsQuery } from "../../redux/apis/invoiceSettingsApi.api";
import { createPosBatch } from "../../graphql/postgress_graphql/customMutations";
import { ToWords } from "to-words";
import moment from "moment";
import API_ENDPOINTS from "../../apiEndpoints";
let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = "0" + dd;
if (mm < 10) mm = "0" + mm;

const todayDate = yy + "-" + mm + "-" + dd;

function NewPos({ isVoucher }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();
  const params = location.state || {
    id: parseInt(
      new URLSearchParams(window.location.search).get("transaction")
    ),
    view: parseInt(
      new URLSearchParams(window.location.search).get("transaction")
    )
      ? true
      : false,
  };
  const newItemObj = {
    itemCode: { label: "", value: "" },
    name: { label: "", value: "" },
    priceType: { label: "", value: "" },
    ledgerAccount: { label: "", value: "" },
    HSN: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    qty: 0,
    units: "",
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: "",
    taxability: { label: "", value: "" },
    manualDiscount: false,
    manualCess: false,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: "0000",
    editable: true,
    new: true,
  };
  const toWords = new ToWords();
  dispatch(display());

  const { Enable_CreditPeriod, Enable_ItemWiseEntry } = useSelector(
    (state) => state.paymentSettingsReducer
  );
  // const InvoiceSettings = useSelector(
  //   (state) => state.invoiceSettingsReducer
  // )?.Pos;
  const {
    data: InvoiceSettingsList,
    isLoading: InvoiceSettingsListLoading,
    isError: InvoiceSettingsListError,
    // refetch
  } = useListInvoiceSettingsQuery(
    { type: "ALL" },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const InvoiceSettings = useMemo(() => {
    if (!InvoiceSettingsList) return [];
    return InvoiceSettingsList.find((e) => e.typecd == "PosSettings");
  }, [InvoiceSettingsList]);
  const [creditPeriod, setCreditPeriod] = useState("");
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]);
  const [itemData, setItemData] = useState({});
  const [state, setState] = useState({
    reason: "",
    errorFields: {
      reason: "",
    },
    errorStatus: {
      reason: false,
    },
  });

  const [accNames, setAccNames] = useState([]);
  const [expenceAccNames, setExpenceAccNames] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const [fromDayDate, setFromDayDate] = useState("");
  const [endDayDate, setEndDayDate] = useState("");
  const [paymentAccordion, setPaymentAccordion] = useState(true);
  const [invoiceEntry, setInvoiceEntry] = useState([]);
  const [tcsOptionValue, setTcsoptionValue] = useState("");
  const [tdsOptionValue, setTdsoptionValue] = useState("");
  const [totTaxAmt, setTotTaxAmt] = useState(0);
  const [totDiscount, setTotDicount] = useState(0);
  const [totGSTCess, setTotGSTCess] = useState(0);
  const [totNetAmt, setTotNetAmt] = useState(0);
  const [totGST, setTotGST] = useState(0);
  const [totAmt, setTotAmt] = useState(0);
  const [companyState, setCompanyState] = useState("");
  const [itemID, setItemID] = useState("");
  const [itemType, setItemType] = useState("");
  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const [netAmountToPay, setNetAmountToPay] = useState(0);
  const [amountAfterDiscount, setAmountAfterDiscount] = useState(0);
  const [amountAfterTCS, setAmountAfterTCS] = useState(0);
  const [amountAfterTDS, setAmountAfterTDS] = useState(0);
  const [companyData, setCompanyData] = useState([]);
  const [partyDeliveryAddressEntity, setPartyDeliveryAddressEntity] = useState(
    {}
  );
  const [partyBillAddressEntity, setPartyBillAddressEntity] = useState({});
  const [invTransArr, setInvTransArr] = useState([]);
  const [paymentTransArr, setPaymentTransArr] = useState([]);
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [itemsRows, setItemsRows] = useState([]);
  const [tcsSections, setTcsSections] = useState([]);
  const [tdsSections, setTdsSections] = useState([]);
  const [transGeneralSettingsFlag, setTransGeneralSettingsFlag] = useState(-1);
  const [partyNameOptions, setPartyNameOptions] = useState([]);
  const [partyAccountID, setPartyAccountID] = useState("");
  const [linkedTransArr, setLinkedTransArr] = useState([]);
  const [voucherArr, setVoucherArr] = useState([]);
  const [transVoucherArr, setTransVoucherArr] = useState([]);
  const [paymentTransID, setPaymentTransID] = useState("");
  const [displayAllAccounts, setDisplayAllAccounts] = useState(false);
  const [currentVoucherNo, setCurrentVoucherNo] = useState("");
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [units, setunits] = useState([]);
  const [unitsObj, setUnitsObj] = useState({});
  const [lastInvoiceDate, setLastInvoiceDate] = useState("");
  const [position, setPosition] = useState({ x: 1400, y: 600 });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [registrationType, setRegistrationType] = useState("");
  const [tabvalue, setTabValue] = useState("1");
  const [itemValid, setItemValid] = useState(true);
  const [nonItemValid, setNonItemValid] = useState(true);
  const [partyType, setPartyType] = useState("CUSTOMER");
  const [isFocusItemRow, setIsFocusItemRow] = useState(false);
  const [isFocusNonItemRow, setIsNonItemFocusRow] = useState(false);
  const [tableErrArr, setTableErrArr] = useState([]);
  const [itemCodes, setItemCodes] = useState([]);
  const [itemNames, setItemNames] = useState([]);
  const [currentDouments, setCurrentDocuments] = useState([]);

  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}`;
  const endDrag = () => setIsDragging(false);
  useEffect(() => {
    const onDrag = (e) => {
      if (!isDragging) return;
      let newY = e.clientY - offset.y;
      let newX = e.clientX - offset.x;
      newY = Math.max(300, newY);
      newY = Math.min(640, newY);
      newX = Math.max(100, newX);
      newX = Math.min(1445, newX);
      setPosition((prevPosition) => ({
        ...prevPosition,
        y: newY,
        x: newX,
      }));
    };

    if (isDragging) {
      window.addEventListener("mousemove", onDrag);
      window.addEventListener("mouseup", endDrag);
      return () => {
        window.removeEventListener("mousemove", onDrag);
        window.removeEventListener("mouseup", endDrag);
      };
    }
  }, [isDragging, offset.x, offset.y]);
  const [items, setItems] = useState([
    {
      itemCode: { label: "", value: "" },
      name: { label: "", value: "" },
      priceType: { label: "", value: "" },
      ledgerAccount: { label: "", value: "" },
      HSN: {
        label: "",
        value: "",
        companyID: "",
        hsnID: "",
        codeType: "",
        description: "",
      },
      qty: 0,
      units: { label: "", value: "" },
      rate: 0,
      amount: 0,
      dicount: 0,
      taxableAMount: 0,
      GSTRate: "",
      taxability: { label: "", value: "" },
      manualDiscount: false,
      manualCess: false,
      IGST: "0.00",
      CGST: "0.00",
      SGST: "0.00",
      GSTCess: 0,
      netAmount: "0000",
      editable: true,
      new: true,
    },
  ]);

  const [nonItems, setNonItems] = useState([
    {
      ledgerAccount: { label: "", value: "" },
      HSN: {
        label: "",
        value: "",
        companyID: "",
        hsnID: "",
        codeType: "",
        description: "",
      },
      description: "",
      taxableAMount: 0,
      GSTRate: "",
      taxability: { label: "", value: "" },
      manualDiscount: false,
      manualCess: false,
      IGST: "0.00",
      CGST: "0.00",
      SGST: "0.00",
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
    },
  ]);
  const [nonItemEditedRow, setNonItemEditedRow] = useState({
    ledgerAccount: { label: "", value: "" },
    HSN: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    description: "",
    taxableAMount: 0,
    GSTRate: "",
    taxability: { label: "", value: "" },
    manualDiscount: false,
    manualCess: false,
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  });
  const [nonItemTempRow, setNonItemTempRow] = useState({
    ledgerAccount: { label: "", value: "" },
    HSN: {
      label: "",
      value: "",
      companyID: "",
      hsnID: "",
      codeType: "",
      description: "",
    },
    description: "",
    taxableAMount: 0,
    GSTRate: "",
    taxability: { label: "", value: "" },
    manualDiscount: false,
    manualCess: false,
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  });
  const [billingAddressDetails, setBillingAddressDetails] = useState({
    billingAddress: "",
    states: { label: "", value: "" },
    district: { label: "", value: "" },
    country: { label: "", value: "" },
    pincode: "",
    stateCD: "",
    countryCD: "",
    districtCD: "",
    gstin: "",
    customerName: "",

    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      billingAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
      gstin: "",
      customerName: "",
    },
  });
  const [deliveryAddressDetails, setDeliveryAddressDetails] = useState({
    deliveryAddress: "",
    states: { label: "", value: "" },
    district: { label: "", value: "" },
    country: { label: "", value: "" },
    pincode: "",
    stateCD: "",
    countryCD: "",
    districtCD: "",
    gstin: "",
    customerName: "",

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      deliveryAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
      gstin: "",
      customerName: "",
    },
  });
  const [initialState, setInitialState] = useState({
    orderNumber: "",
    entryDate: todayDate,
    invoiceDate: todayDate,
    customerOrderDate: todayDate,
    voucherNumber: "",
    partyName: "",
    supplier: "",
    paymentType: "Cash",
    receivedAmount: 0, // initial ,it was ""
    receivedAccount: { label: "Cash A/c", value: 3 },
    creditPeriod: "",
    bankReferenceNo: "",
    dueDate: todayDate,
    tdsFlag: "",
    tdsOptions: "",
    tdsAmount: 0, // initial ,it was ""
    adjustments: 0, // initial ,it was ""
    currency: { label: "Rupee (₹)", value: "1", sign: "₹", code: "INR" },
    currencyRate: 1,
    ineligibleITCFlag: "",
    reverseChargeFlag: 0,
    remarks: "",
    placeOfSupply: { label: "", value: "" },
    address: "",
    billingAddress: "",
    deliveryAddress: "",
    gstin: "",
    transportMode: "",
    vehicleNumber: "",
    dateOfDispatch: todayDate,
    gstCategory: "",
    ewayBillNo: "",
    transactionVoucher: "",
    CancelFlag: 0,
    tcsFlag: 0,
    tcsOptions: "",
    tdsPercent: "",
    tcsPercent: "",
    tcsAmount: 0,
    manualTCSAmt: 0,
    manualTDSAmt: 0,
    seriesVouchers: { label: "", value: "" },
    transactionSeries: { label: "", value: "" },
    consigneeName: "",
    consigneeGST: "",
    roundOff: 0,
    adjustmentsType: "1",
    adjustmentsValue: 0,
    balanceDueAmt: 0,
    partyCategory: "",
    partyContactNumber: "",
    manualTcsFlag: 0,
    manualTdsFlag: 0,
    paymentDeletionFlag: false,
    taxability: { label: "", value: "" },
    partyCreditLimit: 0,
    errorStatus: {
      orderNumber: false,
      entryDate: false,
      invoiceDate: false,
      customerOrderDate: false,
      voucherNumber: false,
      partyName: false,
      paymentType: false,
      receivedAmount: false,
      receivedAccount: false,
      creditPeriod: false,
      bankReferenceNo: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      tcsFlag: false,
      tcsOptions: false,
      tcsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      currency: false,
      gstin: false,
      currencyRate: false,
      transportMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      ewayBillNo: false,
      transactionVoucher: false,
      seriesVouchers: false,
      transactionSeries: false,
      consigneeName: false,
      consigneeGST: false,
      roundOff: false,
      tdsPercent: false,
      tcsPercent: false,
      adjustmentsType: false,
      adjustmentsValue: false,
      balanceDueAmt: false,
      partyContactNumber: false,
      taxability: false,
    },
    errorFields: {
      orderNumber: "",
      entryDate: "",
      invoiceDate: "",
      customerOrderDate: "",
      voucherNumber: "",
      partyName: "",
      paymentType: "",
      receivedAmount: "",
      receivedAccount: "",
      creditPeriod: "",
      bankReferenceNo: "",
      dueDate: "",
      tcsFlag: "",
      tcsOptions: "",
      tcsAmount: "",
      tdsFlag: "",
      tdsOptions: "",
      currency: "",
      tdsAmount: "",
      adjustments: "",
      ineligibleITCFlag: "",
      currencyRate: "",
      reverseChargeFlag: "",
      remarks: "",
      placeOfSupply: "",
      address: "",
      gstin: "",
      transportMode: "",
      vehicleNumber: "",
      dateOfDispatch: "",
      ewayBillNo: "",
      transactionVoucher: "",
      seriesVouchers: "",
      transactionSeries: "",
      consigneeName: "",
      consigneeGST: "",
      tdsPercent: "",
      tcsPercent: "",
      roundOff: "",
      adjustmentsType: "",
      adjustmentsValue: "",
      balanceDueAmt: "",
      partyContactNumber: "",
      taxability: "",
    },
  });
  const [data, setData] = useState({ ...initialState });
  const [initItemTableDta, setInitItemTableDta] = useState([]);
  const [reNavigate, setReNavigate] = useState("");
  let [modalOpen, setModalOpen] = useState(false);
  let saveV = true;
  function deepEqual(obj1, obj2) {
    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return obj1 === obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  const [aTags, setATags] = useState(document.getElementsByTagName("a").length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName("a").length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName("a").length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  const handleNavigationBlocker = (value) => {
    dispatch(setNavigationBlocked(value));
  };

  useEffect(() => {
    if (
      !deepEqual(data, initialState) ||
      itemsRows.length !== initialAttachments.length
    ) {
      handleNavigationBlocker(true);
    }
    return () => {
      handleNavigationBlocker(false);
    };
  }, [data, aTags]);

  const [previewSalesTaxableModal, setPreviewSalesTaxableModal] =
    useState(false);
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate("/companysetup");
    }
  }, []);
  function formVaidation(objData) {
    let isvalid = true;
    let obj = { ...data };
    Object.keys(objData).map((itemKey) => {
      if (itemKey === "seriesVouchers") {
        if (objData[itemKey]?.value === "") {
          isvalid = false;
          obj.errorFields.seriesVouchers = "Invoice Series Name is Required";
          obj.errorStatus.seriesVouchers = true;
        } else {
          obj.errorFields.seriesVouchers = "";
          obj.errorStatus.seriesVouchers = false;
        }
      }
      if (itemKey === "currencyRate") {
        if (objData[itemKey] === 0 || objData[itemKey] === "") {
          isvalid = false;
          obj.errorStatus.currencyRate = true;
          setTabValue("2");
          showWarningSnackbar("Please enter the Currency Rate");
        } else {
          obj.errorFields.currencyRate = "";
          obj.errorStatus.currencyRate = false;
        }
      }
      if (itemKey === "invoiceDate") {
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.invoiceDate = "Invoice Date is Required";
          obj.errorStatus.invoiceDate = true;
        } else {
          obj.errorFields.invoiceDate = "";
          obj.errorStatus.invoiceDate = false;
        }
      }

      if (registrationType !== 1) {
        if (itemKey === "taxability") {
          if (objData[itemKey].value === "") {
            isvalid = false;
            obj.errorFields.taxability = "Taxability is required";
            obj.errorStatus.taxability = true;
          } else {
            obj.errorFields.taxability = "";
            obj.errorStatus.taxability = false;
          }
        }
      }

      if (itemKey === "paymentType") {
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.paymentType = "Payment Type is Required";
          obj.errorStatus.paymentType = true;
          setPaymentAccordion(true);
        } else {
          obj.errorFields.paymentType = "";
          obj.errorStatus.paymentType = false;
        }
      }

      // if (itemKey === "receivedAmount") {
      //   if (
      //     objData["paymentType"] == "Cash" ||
      //     objData["paymentType"] == "Bank"
      //   ) {
      //     if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
      //       isvalid = false;
      //       obj.errorFields.receivedAmount = "Received Amount is Required";
      //       obj.errorStatus.receivedAmount = true;
      //     } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
      //       isvalid = false;
      //       obj.errorFields.receivedAmount =
      //         "Amount should be less than Grand Total";
      //       obj.errorStatus.receivedAmount = true;
      //     } else {
      //       obj.errorFields.receivedAmount = "";
      //       obj.errorStatus.receivedAmount = false;
      //     }
      //   }
      // }

      if (itemKey === "receivedAccount") {
        if (
          objData["paymentType"] == "Cash" ||
          objData["paymentType"] == "Bank"
        ) {
          if (objData[itemKey].value == "") {
            isvalid = false;
            obj.errorFields.receivedAccount = "Received Account is Required";
            obj.errorStatus.receivedAccount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAccount = "";
            obj.errorStatus.receivedAccount = false;
          }
        }
      }

      if (itemKey === "adjustments") {
        if (
          !new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(
            objData[itemKey]
          ) &&
          objData[itemKey]?.trim()?.length > 0
        ) {
          isvalid = false;
          obj.errorFields.adjustments = "Invalid Amount Format";
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = "";
          obj.errorStatus.adjustments = false;
        }
      }

      if (itemKey === "bankReferenceNo") {
        if (objData["paymentType"] === "Bank") {
          if (
            !new RegExp(/^\d{9,18}$/).test(objData[itemKey]) &&
            objData[itemKey].trim().length > 0
          ) {
            isvalid = false;
            obj.errorFields.bankReferenceNo =
              "Invalid Bank/UPI Reference number";
            obj.errorStatus.bankReferenceNo = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.bankReferenceNo = "";
            obj.errorStatus.bankReferenceNo = false;
          }
        }
      }
      if (itemKey === "voucherNumber") {
        if (objData[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.voucherNumber = "Invoice Number is Required";
          obj.errorStatus.voucherNumber = true;
        } else {
          let valid = true;
          voucherArr.map((ele) => {
            if (ele.InvoiceNumber !== invoiceEntry.InvoiceNumber) {
              if (ele.VoucherNumber === data.voucherNumber) {
                valid = false;
              }
            }
          });
          if (valid == false) {
            isvalid = false;
            obj.errorFields.voucherNumber = "Invoice Number already exists";
            obj.errorStatus.voucherNumber = true;
          } else {
            obj.errorFields.voucherNumber = "";
            obj.errorStatus.voucherNumber = false;
          }
        }
      }

      if (data.paymentType !== "Credit") {
        if (itemKey === "transactionVoucher") {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.transactionVoucher = "Voucher Number is Required";
            obj.errorStatus.transactionVoucher = true;
            setPaymentAccordion(true);
          } else {
            let valid = true;
            transVoucherArr.map((ele) => {
              if (ele.VoucherNumber !== currentVoucherNo)
                if (ele.VoucherNumber === data.transactionVoucher) {
                  valid = false;
                }
            });

            if (valid == false) {
              isvalid = false;
              obj.errorFields.transactionVoucher =
                "Voucher Number already exists";
              obj.errorStatus.transactionVoucher = true;
              setPaymentAccordion(true);
            } else {
              obj.errorFields.transactionVoucher = "";
              obj.errorStatus.transactionVoucher = false;
            }
          }
        }
      }

      if (itemKey === "remarks") {
        if (
          objData[itemKey]?.trim()?.length > 250 &&
          objData[itemKey]?.trim()?.length > 0
        ) {
          isvalid = false;
          obj.errorFields.remarks =
            "Description must be less than 250 characters";
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = "";
          obj.errorStatus.remarks = false;
        }
      }
      if (itemKey === "partyContactNumber") {
        if (
          !new RegExp(
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
          ).test(objData[itemKey]) &&
          objData[itemKey].trim().length > 0
        ) {
          isvalid = false;
          obj.errorFields.partyContactNumber = "Invalid Invoice Order Number";
          obj.errorStatus.partyContactNumber = true;
        } else {
          obj.errorFields.partyContactNumber = "";
          obj.errorStatus.partyContactNumber = false;
        }
      }
    });

    setData(obj);

    return isvalid;
  }
  async function getInvoiceMasterData(data) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(
        graphqlOperation(getInvoiceMasterCustom, { invoiceid: data })
      );
      if (res.data.getInvoiceMaster !== null) {
        setInvoiceEntry(res.data.getInvoiceMaster?.[0]);
        setBackdropOpen(false);
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log("error", error);
    }
  }
  async function savePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let masterArr = [];
      let linkedArr = [];
      if (data.paymentType !== "Credit") {
        const masterData = {
          bankreferencenumber: data.bankReferenceNo,
          comments: "",
          entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          transactiontypecd:
            data.paymentType === "Cash"
              ? "CashReceipt"
              : data.paymentType === "Bank"
              ? "BankReceipt"
              : "Credit",
          vouchercode:
            transGeneralSettingsFlag === -1 ? data.transactionVoucher : "",
          serialnumber: data.transactionSeries.value,
        };

        masterArr.push(masterData);
        paymentTransArr.map((ele, index) => {
          const paymentTransDetails = {
            accountid: ele.accID,
            comments: data.remarks,
            creditamount: Number(ele.creditAmt).toFixed(2),
            debitamount: Number(ele.debitAmt).toFixed(2),
            entryordernumber: index + 1,

            transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
          };
          tranSDetailsArr.push(paymentTransDetails);
        });

        const linkCurrentPayment = {
          linkedamount: data.receivedAmount,
          transactiontypecd: "PosInvoice",
          isdirect: 1,
          objectattribute: data.voucherNumber,
          objectid: invID,
          objecttype: data.paymentType,

          accountid: partyAccountID === "" ? 0 : partyAccountID,
          paymentvouchernumber: data?.transactionVoucher,
        };
        linkedArr.push(linkCurrentPayment);
        linkedTransArr.map(async (ele) => {
          let linkTransData = {
            linkedamount: ele.linkedamount,
            transactiontypecd: "PosInvoice",
            isdirect: 0,
            objectattribute: data?.voucherNumber,
            objectid: invID,
            objecttype: ele.transactiontypecd,
            transactionid: ele.transactionid,
          };
          linkedArr.push(linkTransData);
        });
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTime, {
            transactionmaster: JSON.stringify(masterArr),
            transactiondetails: JSON.stringify(tranSDetailsArr),
            transactionattachment: JSON.stringify([]),
            transactiontdsdetails: JSON.stringify([]),
            transactionrelation: JSON.stringify(linkedArr),
            mode: 1,
            transactiontcsdetails: JSON.stringify([]),
          })
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function saveLinkTranSaction(invID) {
    try {
      linkedTransArr.map(async (ele) => {
        let linkTransData = {
          LinkedAmount: ele.LinkedAmount,
          TransactionTypeCD: "PosInvoice",
          IsDirect: 0,
          ObjectAttribute: data?.voucherNumber,
          ObjectID: invID,
          ObjectType: ele.TransactionTypeCD,
          TransactionID: ele.TransactionID,
        };
        const res = await API.graphql(
          graphqlOperation(createTransactionRelation, {
            createTransactionRelationInput: linkTransData,
          })
        );
      });
    } catch (error) {
      console.log("error", error);
    }
  }
  async function saveCurrentLinkPayment(invID, transID) {
    try {
      const linkCurrentPayment = {
        LinkedAmount: data.receivedAmount,
        TransactionTypeCD: "PosInvoice",
        IsDirect: 1,
        ObjectAttribute: data.voucherNumber,
        ObjectID: invID,
        ObjectType: data.paymentType,
        TransactionID: transID,
        AccountID: partyAccountID === "" ? 0 : partyAccountID,
        PaymentVoucherNumber: data?.transactionVoucher,
      };
      const res = await API.graphql(
        graphqlOperation(createTransactionRelation, {
          createTransactionRelationInput: linkCurrentPayment,
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  }
  async function addAttachmets(Id) {
    const attachedArr = itemsRows.map((ele) => ({
      AttachmentID: ele.AttachmentID,
      InvoiceID: Id,
      DocumentName: ele.DocumentName,
      AttachmentName: ele.ImageName,
      AttachmentURL: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.ImageName}`,
      Type: ele?.Type,
    }));
    try {
      if (attachedArr?.length > 0) {
        const resMsmeattachments = await API.graphql(
          graphqlOperation(createInvoiceAttachmentArray, {
            InvoiceAttachment: JSON.stringify(attachedArr),
          })
        );
        let responses = itemsRows.map((element) => {
          if (element.file) {
            return uploadToServer(
              element.file,
              element.ImageName,
              element.Type
            );
          }
        });
        return resMsmeattachments?.data?.createInvoiceAttachmentArray != null;
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function saveChanges(obj) {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      // receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    let itemValid = true;
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (totNetAmt === 0 || ele?.itemCode?.value !== "") {
          if (ele?.itemCode?.value === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("itemCode" + ind);
            requireds.push("Item Code");
          }
          if (ele?.name?.value === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("itemName" + ind);
            requireds.push("Item Name");
          }

          if (ele?.qty === 0 || ele?.qty === "0" || ele?.qty === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("qty" + ind);
            requireds.push("Quantity");
          }
          if (
            ele?.qty !== "" &&
            !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)
          ) {
            isvalid = false;
            itemValid = false;
            invalids.push(" Quantity");
          }
          if (ele?.qty !== 0 && (ele?.rate == "" || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push("Rate");
            errorArr.push("rate" + ind);
          }

          if (registrationType !== 1) {
            // if (data?.taxability?.value === "") {
            //   isvalid = false;
            //   itemValid = false;
            //   requireds.push("Taxability");
            //   errorArr.push("taxability" + ind);
            // }
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value === ""
            ) {
              if (ele?.GSTRate === "") {
                isvalid = false;
                itemValid = false;
                requireds.push("GST Rate");
                errorArr.push("GSTRate" + ind);
              }
            }
          }
          if (
            ele?.dicount !== "" &&
            Number(ele?.dicount) > Number(ele?.amount)
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push("dicount" + ind);
            invalidDiscount.push(" Discount");
          }
        }

        return isvalid;
      });
      if (updatedTableItemRow.length === 0) {
        setItems([newItemObj]);

        isvalid = false;
        setBackdropOpen(false);
        showWarningSnackbar("Please complete the actions in your entry table");
      }
      if (isvalid) {
        try {
          const comments = data.remarks.split("\n");
          let invMasterArr = [];
          let invDispatchArr = [];
          let invLineItemArr = [];
          let invNonLineItemArr = [];
          let tcsArr = [];
          let invAddArr = [];
          let invTransactionArray = [];
          let invLineGstArr = [];
          let invLineNonGstArr = [];
          let randomNum = Math.floor(Math.random() * 100 + 1);
          let timeStamp = Math.floor(new Date().getTime() / 1000);
          let randomNumber = randomNum + timeStamp.toString().slice(3, 10);
          const phoneContacts = {
            callallowed: "0",
            countrycode: "1",
            objecttype: "Pos",
            id: 0,
            objectid: companyData.companyid,
            phonenumber: data.partyContactNumber,
            promotionssignup: "0",
            smsallowed: "0",
            verifieddatetime: 0,
            whatsappallowed: "0",

            expiredtimestamp: 0,
          };

          const resPhoneContact = await API.graphql(
            graphqlOperation(createPhoneContacts, {
              createPhoneContactsInput: [phoneContacts],
            })
          );
          const posPartyData = {
            partycontactnumberid:
              resPhoneContact.data.createPhoneContacts?.[0]?.id,
            partyname: partyName,
            pospartyid: 0,
            expiredtimestamp: 0,
          };
          const resPosData = await API.graphql(
            graphqlOperation(createPOSParty, {
              createPOSPartyInput: posPartyData,
            })
          );
          const posData = {
            partyposid: resPosData.data.createPOSParty.pospartyid,
            expiredtimestamp: 0,
            posid: 0,
          };
          const resInvoicePosData = await API.graphql(
            graphqlOperation(createInvoicePOSDetails, {
              createInvoicePOSDetailsInput: posData,
            })
          );
          const invMasterData = {
            adjustmentamount: Number(adjustments),
            comments: comments.join("**"),
            reversechargeflag:
              data.reverseChargeFlag === "" ? 0 : data.reverseChargeFlag,
            balancedueamount: data.balanceDueAmt,
            creditduration: creditPeriod === "" ? 0 : Number(creditPeriod),
            customerordernumber: orderNumber === "" ? 0 : orderNumber,
            customerorderdate:
              customerOrderDate === ""
                ? 0
                : Math.floor(new Date(customerOrderDate).getTime() / 1000),
            exchangerate: Number(receivedAmount),
            invoiceamount: netAmountToPay,
            invoicebillingaddressid: 10,
            invoicecurrencycd: "",
            invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
            invoicedeliveryaddressid: 10,
            invoicelinetypecd: "",
            invoicenumber: data.voucherNumber == "" ? 0 : data.voucherNumber,
            invoicetaxabletypecd: taxability?.value,
            invoicetypecd: "PosInvoice",
            partyid: resPosData.data.createPOSParty.pospartyid,
            paymentaccountid:
              receivedAccount.value == "" ? 0 : receivedAccount.value,
            placeofsupply: placeOfSupply.value,
            paymenttype: paymentType,
            receipturl: "",
            receivedamount: Number(receivedAmount),
            bankreferencenumber:
              paymentType === "Bank" ? data?.bankReferenceNo : "",
            entrydate: Math.floor(new Date().getTime() / 1000),
            transactiontypecd: "PosInvoice",
            tcsapplicableflag: data.tcsFlag,
            serialnumber: data.seriesVouchers.value,
            consigneename:
              data.consigneeName !== ""
                ? data.consigneeName
                : data.partyName.label,
            consigneegstin:
              data.consigneeGST !== "" ? data.consigneeGST : data.gstin,
            companystate: companyState,
            roundoffamount: data.roundOff,
            discounttype: data.adjustmentsType,
            discountvalue: data.adjustmentsValue,
            currencycode: data.currency.value,
            currencyrate: data.currencyRate,
          };
          invMasterArr.push(invMasterData);
          if (items.length > 0) {
            items.map((ele, index) => {
              if (ele?.itemCode?.value !== "") {
                const lineItem = {
                  hsnsaccode: ele.HSN.value === "" ? 0 : ele.HSN.value,
                  invoicelineitemtype: "ITEM",
                  itemamount: Number(ele.amount),
                  itemdiscount: Number(ele.dicount),
                  itemid: Number(ele.name.value),
                  itemrate: Number(ele.rate),
                  taxability: ele.taxability.value,
                  lineitemnumber: index + 1,
                  netamount: Number(ele.netAmount),
                  quantity: Number(ele.qty),
                  pricetype: ele?.priceType?.label,
                  unittypecd: ele.units,
                  invoiceitemid: index + 1,
                };

                invLineItemArr.push(lineItem);
                const gstData = {
                  cessamount: Number(ele.GSTCess),
                  gstamount: Number(ele.IGST),
                  gstrate: Number(ele.GSTRate),
                  gsttypecd: "",
                  invoiceitemid: index + 1,
                };
                invLineGstArr.push(gstData);
              }
            });
          }
          const tcsData = {
            adjustmentamount: Number(data.adjustments),
            gstcesstotal: Number(totGSTCess),
            ineligibletcflag:
              data.ineligibleITCFlag === "" ? 0 : data.ineligibleITCFlag,
            reversechargeflag:
              data.reverseChargeFlag === "" ? 0 : data.reverseChargeFlag,
            tcsamount: Number(data.tcsAmount),
            tcsapplicablecd: data.tcsFlag === "" ? 0 : data.tcsFlag,
            tcssection: data.tcsOptions,
            totaltaxableamount: Number(totTaxAmt),
            tcspercentage: Number(data.tcsPercent),
            tcsmanual: data.manualTcsFlag,
          };
          tcsArr.push(tcsData);
          invTransArr.map((ele, ind) => {
            let obj = {
              accountid: ele.accID,
              comments: data.remarks,
              debitamount: Number(ele.debitAmt).toFixed(2),
              creditamount: Number(ele.creditAmt).toFixed(2),
              entryordernumber: ind + 1,
              transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
            };
            invTransactionArray.push(obj);
          });
          const attachedArr = itemsRows.map((ele) => ({
            documentname: ele.documentname,
            attachmentname: ele.imagename,
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
            type: ele?.type?.split("/")[1],
          }));

          const resSalesInvoice = await API.graphql(
            graphqlOperation(createSalesInvoice, {
              createSalesInvoiceInput: {
                denominations: JSON.stringify([]),
                invoicedispatch: JSON.stringify(invDispatchArr),
                invoicelinegst: JSON.stringify(invLineGstArr),
                invoicelinenongst: JSON.stringify(invLineNonGstArr),
                invoicelineitems: JSON.stringify(invLineItemArr),
                invoicelinenonitems: JSON.stringify(invNonLineItemArr),
                invoicetcsdetails: JSON.stringify(tcsArr),
                invoicetransactionmaster: JSON.stringify(invMasterArr),
                partyaddressentity: JSON.stringify(invAddArr),
                transactiondetails: JSON.stringify(invTransactionArray),
                invoiceattachment: JSON.stringify(attachedArr),
              },
            })
          );
          if (resSalesInvoice.data.createSalesInvoice.statuscode == "Success") {
            setBackdropOpen(false);
            // addAttachmets(resSalesInvoice.data.createSalesInvoice.InvoiceID);
            savePaymentDetails(
              resSalesInvoice.data.createSalesInvoice.invoiceid
            );
            let responses = itemsRows.map((element) => {
              if (element.file) {
                return uploadToServer(
                  element.file,
                  element.imagename.replace(
                    "${id}",
                    resSalesInvoice.data.createSalesInvoice.invoiceid
                  ),
                  element.type
                );
              }
            });
            showSuccessSnackbar("Pos generated successfully");
            dispatch(
              VoucherSettingsApi.util.invalidateTags([
                { type: "listVoucherSettings", id: "PosInvoice" },
              ])
            );
            dispatch(
              VoucherSettingsApi.util.invalidateTags([
                "listUsedVoucherSettings",
              ])
            );
            if (obj.new === false) {
              // navigate("/salesInvoiceReport");
             
            } else {
              window.location.reload();
            }
          } else {
            setBackdropOpen(false);
            // setItemValid(false);
            // showWarningSnackbar("Please complete the highlighted fields");
            showErrorSnackbar(
              resSalesInvoice.data.createSalesInvoice.statusmessage
            );
          }
        } catch (error) {
          setBackdropOpen(false);
          showErrorSnackbar("Some thing went wrong.Please try again");
          console.log("error", error);
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + " " + "is required");
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + " " + "are required");
        }
        setItemValid(itemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  async function saveEditChanges() {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    let itemValid = true;
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;

      updatedTableItemRow.map((ele, ind) => {
        if (totNetAmt === 0 || ele?.itemCode?.value !== "") {
          if (ele?.itemCode?.value === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("itemCode" + ind);
            requireds.push("Item Code");
          }
          if (ele?.name?.value === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("itemName" + ind);
            requireds.push("Item Name");
          }

          if (ele?.qty === 0 || ele?.qty === "0" || ele?.qty === "") {
            isvalid = false;
            itemValid = false;
            errorArr.push("qty" + ind);
            requireds.push("Quantity");
          }
          if (
            ele?.qty !== "" &&
            !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)
          ) {
            isvalid = false;
            itemValid = false;
            invalids.push(" Quantity");
          }
          if (ele?.qty !== 0 && (ele?.rate == "" || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push("Rate");
            errorArr.push("rate" + ind);
          }

          if (registrationType !== 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value === ""
            ) {
              if (ele?.GSTRate === "") {
                isvalid = false;
                itemValid = false;
                requireds.push("GST Rate");
                errorArr.push("GSTRate" + ind);
              }
            }
          }
          if (
            ele?.dicount !== "" &&
            Number(ele?.dicount) > Number(ele?.amount)
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push("dicount" + ind);
            invalidDiscount.push(" Discount");
          }
        }

        return isvalid;
      });
      if (updatedTableItemRow.length === 0) {
        setItems([newItemObj]);

        isvalid = false;
        setBackdropOpen(false);
        showWarningSnackbar("Please complete the actions in your entry table");
      }
      if (isvalid) {
        const comments = data.remarks.split("\n");
        const phoneContacts = {
          id: invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
            ?.relatedphonecontacts[0]?.id,
          callallowed: "",
          countrycode: "1",
          objecttype: "Pos",
          objectid: companyData.companyid,

          phonenumber: data.partyContactNumber,
          promotionssignup: "",
          smsallowed: "",
          verifieddatetime: 0,
          whatsappallowed: "",
          expiredtimestamp: 0,
        };

        const resPhoneContact = await API.graphql(
          graphqlOperation(createPhoneContacts, {
            createPhoneContactsInput: [phoneContacts],
          })
        );
        const posPartyData = {
          partycontactnumberid:
            invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
              ?.relatedphonecontacts[0]?.id,
          partyname: partyName,
          pospartyid:
            invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
              ?.pospartyid,
          expiredtimestamp: 0,
        };
        const resPosData = await API.graphql(
          graphqlOperation(createPOSParty, {
            createPOSPartyInput: posPartyData,
          })
        );

        const posData = {
          posid: invoiceEntry.relatedinvoiceposdetails[0]?.posid,
          partyposid:
            invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
              ?.pospartyid,
          expiredtimestamp: 0,
        };
        const resInvoicePosData = await API.graphql(
          graphqlOperation(createInvoicePOSDetails, {
            createInvoicePOSDetailsInput: posData,
          })
        );

        const masterData = {
          adjustmentamount: Number(adjustments),
          comments: comments.join("**"),
          expiredtimestamp: 0,
          reversechargeflag:
            data.reverseChargeFlag === "" ? 0 : data.reverseChargeFlag,
          balancedueamount: Number(data.balanceDueAmt),
          creditduration: Number(creditPeriod),
          customerordernumber: orderNumber === "" ? 0 : orderNumber,
          customerorderdate:
            customerOrderDate === ""
              ? 0
              : Math.floor(new Date(customerOrderDate).getTime() / 1000),
          exchangerate: Number(receivedAmount),
          invoiceamount: netAmountToPay,
          invoicebillingaddressid: 10,
          invoicecurrencycd: "",
          invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
          invoicedeliveryaddressid: 10,
          invoiceid: invoiceEntry.invoiceid,
          invoicenumber: data.voucherNumber,
          serialnumber: data.seriesVouchers.value,
          invoicetaxabletypecd: taxability?.value,
          invoicetypecd: "PosInvoice",
          partyid:
            invoiceEntry.relatedinvoiceposdetails[0]?.relatedposparty[0]
              ?.pospartyid,
          paymentaccountid:
            receivedAccount.value == "" ? 0 : receivedAccount.value,
          placeofsupply: placeOfSupply.value,

          paymenttype: paymentType,
          receipturl: "",
          receivedamount: Number(receivedAmount),
          tcsapplicableflag: data.tcsFlag,
          consigneename: "",

          consigneegstin: "",

          companystate: companyState,
          roundoffamount: Number(data.roundOff).toFixed(2),
          discounttype: Number(data.adjustmentsType),
          discountvalue: Number(data.adjustmentsValue),
          currencycode: data.currency.value,
          currencyrate: data.currencyRate,
          cancelremark: "",
          deleteremark: "",
          financialyearid: userPreferece?.financialYear?.financialyearid,
          cancelflag: 0,
          invoicelinetyped: "",
          paymentstatus: 0,
        };
        updateInvoiceMasterData(masterData);
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + " " + "is required");
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + " " + "are required");
        }
        setItemValid(itemValid);
      }
    }
  }
  async function updateInvoiceMasterData(masterData) {
    try {
      let variables = {};
      let invLineItemArr = [];
      let invLineGstArr = [];
      let invTransactionArray = [];

      [...items, ...deletedItems].map(async (ele, index) => {
        if (ele?.itemCode?.value !== "") {
          const lineItem = {
            hsnsaccode: ele?.HSN?.value === "" ? 0 : ele?.HSN?.value,
            invoicelineitemtype: "ITEM",
            itemamount: Number(ele.amount),
            itemdiscount: Number(ele.dicount),
            itemid: Number(ele?.name?.value),
            itemrate: Number(ele.rate),
            taxability: data?.taxability?.value,
            lineitemnumber: index + 1,
            netamount: Number(ele.netAmount),
            quantity: Number(ele.qty),
            pricetype: ele?.priceType?.label,
            unittypecd: ele.units,
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            lotid: 0,
            companybranchid: 0,
          };
          invLineItemArr.push(lineItem);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            gstamount: Number(ele.IGST),
            gstrate: Number(ele.GSTRate),
            gsttypecd: "",
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
          };
          invLineGstArr.push(gstData);
        }
      });

      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(itemsRows.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (
          !idsInArray2.has(item.attachmentid) &&
          typeof item.attachmentid !== "string"
        ) {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          arr = itemsRows.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = itemsRows.filter(
        (item2) =>
          !currentDouments.some(
            (item1) => item1.attachmentid == item2.attachmentid
          )
      );

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele) => ({
        attachmentid:
          typeof ele.attachmentid === "string" ? 0 : ele.attachmentid,
        invoiceid: invoiceEntry?.invoiceid,
        documentname: ele.documentname,
        attachmentname: ele.imagename,
        attachmenturl: `${
          API_ENDPOINTS.REACT_APP_S3_BUCKET_URL
        }/${ele.imagename.replace("${id}", invoiceEntry?.invoiceid)}`,
        type: ele?.type,
        companybranchid: 0,
        expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
      }));
      invTransArr.map((ele, ind) => {
        let obj = {
          accountid: ele.accID,
          comments: data.remarks,
          debitamount: Number(ele.debitAmt).toFixed(2),
          creditamount: Number(ele.creditAmt).toFixed(2),
          entryordernumber: ind + 1,
          transactionid:
            invoiceEntry?.relatedinvoicetransactiondetails[0]?.transactionid,
          transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
          enteredtimestamp: Math.floor(
            new Date(data.invoiceDate).getTime() / 1000
          ),
        };
        invTransactionArray.push(obj);
      });

      if (attachedArr?.length > 0) {
        let responses = itemsRows.map((element) => {
          if (element.file) {
            return uploadToServer(
              element.file,
              element.imagename.replace("${id}", invoiceEntry?.invoiceid),
              element.type
            );
          }
        });
      }
      const tcsData = {
        adjustmentamount: Number(data.adjustments),

        expiredtimestamp: 0,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag:
          data.ineligibleITCFlag === "" ? 0 : data.ineligibleITCFlag,
        invoiceid: invoiceEntry?.invoiceid,
        reversechargeflag: data.reverseChargeFlag,
        tcsamount: Number(data.tcsAmount),
        tcsapplicablecd: data.tcsFlag === "" ? 0 : data.tcsFlag,
        tcssection: data.tcsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tcspercentage: Number(data.tcsPercent),
        tcsmanual: data.manualTcsFlag,
        companybranchid: 0,
      };

      variables = {
        createInvoiceMasterInput: masterData,
        createInvoiceLineItemsInput: invLineItemArr,
        createInvoiceLineGSTInput: invLineGstArr,
        createInvoiceAttachmentInput: attachedArr,
        createInvoiceTCSDetailsInput: [tcsData],
        transactionmaster: JSON.stringify([]),
        transactiondetails: JSON.stringify(invTransactionArray),
        transactionattachment: JSON.stringify([]),
        transactiontdsdetails: JSON.stringify([]),
        transactionrelation: JSON.stringify([]),
        mode: 0,
        transactiontcsdetails: JSON.stringify([]),
      };

      const response = await API.graphql(
        graphqlOperation(createPosBatch, variables)
      );
      console.log("response", response);

      updatePaymentDetails(response?.data?.createInvoiceMaster?.invoiceid);
      if (response.data?.createInvoiceMaster?.statuscode === "Error") {
        showWarningSnackbar(response?.data?.createInvoiceMaster.statusmessage);
      } else {
        setBackdropOpen(false);
        showSuccessSnackbar("Pos updated successfully");
        navigate("/allpos?active=pos");
      }
    } catch (error) {
      setBackdropOpen(false);
      showErrorSnackbar("Some thing went wrong.Please  try again");
      console.log("error", error);
    }
  }
  async function updateInvoiceTCSData(invID) {
    try {
      const tcsData = {
        AdjustmentAmount: Number(data.adjustments),
        EnteredTimeStamp:
          invoiceEntry?.RelatedInvoiceTCSDetails?.[0]?.EnteredTimeStamp,
        GSTCessTotal: Number(totGSTCess),
        IneligibleTCFlag:
          data.ineligibleITCFlag === "" ? 0 : data.ineligibleITCFlag,
        InvoiceID: invID,
        ReverseChargeFlag:
          data.reverseChargeFlag === "" ? 0 : data.reverseChargeFlag,
        TCSAmount: Number(data.tcsAmount),
        TCSApplicableCD: data.tcsFlag === "" ? 0 : data.tcsFlag,
        TCSSection: data.tcsOptions,
        TotalTaxableAmount: Number(totTaxAmt),
        TCSPercentage: Number(data.tcsPercent),
        TCSManual: data.manualTcsFlag,
      };
      const restds = await API.graphql(
        graphqlOperation(updateInvoiceTCSDetails, {
          updateInvoiceTCSDetailsInput: tcsData,
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  }
  async function updateItemEntry(invID) {
    try {
      let itemArr = [];
      let gstArr = [];
      if (items.length > 0) {
        items.map(async (ele, index) => {
          if (ele?.itemCode?.value !== "") {
            const lineItem = {
              hsnsaccode:
                ele?.HSN?.value === "" || ele?.HSN?.value === undefined
                  ? 0
                  : ele?.HSN?.value,
              invoicelineitemtype: "ITEM",
              itemamount: Number(ele.amount),
              itemdiscount: Number(ele.dicount),
              itemid: Number(ele?.name?.value),
              itemrate: Number(ele.rate),
              taxability: data?.taxability?.value,
              lineitemnumber: index + 1,
              netamount: Number(ele.netAmount),
              quantity: Number(ele.qty),
              pricetype: ele?.priceType?.label,
              unittypecd: ele.units,
              invoiceid: invID,
              invoiceitemid: index + 1,
            };
            itemArr.push(lineItem);
            // const res = await API.graphql(
            //   graphqlOperation(createInvoiceLineItems, {
            //     createInvoiceLineItemsInput: lineItem,
            //   })
            // );
            const gstData = {
              cessamount: Number(ele.GSTCess),
              gstamount: Number(ele.IGST),
              gstrate: Number(ele.GSTRate),
              gsttypecd: "",
              invoiceid: invID,
              invoiceitemid: index + 1,
            };
            gstArr.push(gstData);
            // const resgst = await API.graphql(
            //   graphqlOperation(createInvoiceLineGST, {
            //     createInvoiceLineGSTInput: gstData,
            //   })
            // );
          }
        });
        const res = await API.graphql(
          graphqlOperation(createInvoiceLineItemsArray, {
            createInvoiceLineItemsInputArray: JSON.stringify(itemArr),
            createInvoiceLineGSTArray: JSON.stringify(gstArr),
          })
        );
      }
      if (nonItems.length > 0) {
        nonItems.map(async (ele, index) => {
          if (ele?.ledgerAccount?.value !== "") {
            const lineNonItem = {
              hsnsaccode: ele?.HSN?.value === "" ? 0 : ele?.HSN?.value,
              incomeaccountid: ele?.ledgerAccount?.value,
              invoicelineitemtype: "NONITEM",
              itemdescription: ele.description,
              taxability: data?.taxability?.value,
              netamount: Number(ele.netAmount),
              taxableamount: Number(ele.taxableAMount),
              invoiceid: invID,
              invoiceitemid: index + 1,
            };
            // invNonLineItemArr.push(lineNonItem);
            const res = await API.graphql(
              graphqlOperation(createInvoiceLineNonItems, {
                createInvoiceLineNonItemsInput: lineNonItem,
              })
            );
            const gstData = {
              CessAmount: Number(ele.GSTCess),
              GSTAmount: Number(ele.IGST),
              GSTRate: Number(ele.GSTRate),
              GSTTypeCD: "",
              InvoiceID: invID,
              InvoiceItemID: index + 1,
            };
            const resgst = await API.graphql(
              graphqlOperation(createInvoiceLineNonGST, {
                createInvoiceLineNonGSTInput: gstData,
              })
            );
          }
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function updateInvoiceTransactionDetails(transID) {
    try {
      let invTransactionArray = [];
      const deleteInvTrans = await API.graphql(
        graphqlOperation(deleteTransactionDetails, {
          TransactionID: transID,
        })
      );
      if (deleteInvTrans.data.deleteTransactionDetails != null) {
        invTransArr.map((ele, ind) => {
          let obj = {
            AccountID: ele.accID,
            Comments: data.remarks,
            DebitAmount: Number(ele.debitAmt).toFixed(2),
            CreditAmount: Number(ele.creditAmt).toFixed(2),
            EntryOrderNumber: ind + 1,
            TransactionID: transID,
            TransactionTypeCD: ele.debitAmt !== 0 ? "Debit" : "Credit",
            EnteredTimeStamp: Math.floor(
              new Date(data.invoiceDate).getTime() / 1000
            ),
          };
          invTransactionArray.push(obj);
        });
        const resTransactionDetails = await API.graphql(
          graphqlOperation(createTransactionDetailsArray, {
            createTransactionDetailsArrayInput:
              JSON.stringify(invTransactionArray),
          })
        );
        const updateTimeStamp = {
          TransactionID: transID,
          EnteredTimeStamp: Math.floor(
            new Date(data.invoiceDate).getTime() / 1000
          ),
        };
        const resUpdateTimeStamp = await API.graphql(
          graphqlOperation(updatetransactionTimeStamp, updateTimeStamp)
        );
      }
    } catch (error) {}
  }
  // async function updatePaymentDetails(invID) {
  //   try {
  //     let tranSDetailsArr = [];
  //     if (data.paymentType !== "Credit") {
  //       if (paymentTransID !== "") {
  //         const masterData = {
  //           TransactionID: paymentTransID,
  //           BankReferenceNumber: data.bankReferenceNo,
  //           EntryDate: Math.floor(new Date(data.entryDate).getTime() / 1000),
  //           Comments: "",
  //           VoucherNumber: data.transactionVoucher,
  //           SerialNumber: data.transactionSeries.value,
  //           TransactionTypeCD:
  //             data.paymentType == "Cash"
  //               ? "CashReceipt"
  //               : data.paymentType == "Bank"
  //               ? "BankReceipt"
  //               : "Credit",
  //         };
  //         const updateTransMaster = await API.graphql(
  //           graphqlOperation(updateTransactionMaster, {
  //             updateTransactionMasterInput: masterData,
  //           })
  //         );
  //         const deletePaymentTrans = await API.graphql(
  //           graphqlOperation(deleteTransactionDetails, {
  //             TransactionID: paymentTransID,
  //           })
  //         );
  //         if (deletePaymentTrans.data.deleteTransactionDetails != null) {
  //           paymentTransArr.map((ele, index) => {
  //             const paymentTransDetails = {
  //               AccountID: ele.accID,
  //               Comments: data.remarks,
  //               CreditAmount: Number(ele.creditAmt).toFixed(2),
  //               DebitAmount: Number(ele.debitAmt).toFixed(2),
  //               EntryOrderNumber: index + 1,
  //               TransactionID:
  //                 updateTransMaster.data.updateTransactionMaster.TransactionID,
  //               TransactionTypeCD: ele.debitAmt !== 0 ? "Debit" : "Credit",
  //               EnteredTimeStamp: Math.floor(
  //                 new Date(data.invoiceDate).getTime() / 1000
  //               ),
  //             };
  //             tranSDetailsArr.push(paymentTransDetails);
  //           });
  //           const resTransactionDetails = await API.graphql(
  //             graphqlOperation(createTransactionDetailsArray, {
  //               createTransactionDetailsArrayInput:
  //                 JSON.stringify(tranSDetailsArr),
  //             })
  //           );
  //         }
  //         const deleteRelationData = await API.graphql(
  //           graphqlOperation(deleteTransactionRelationByObjectAttribute, {
  //             ObjectAttribute: invoiceEntry?.InvoiceNumber,
  //             ObjectID: invoiceEntry.InvoiceID,
  //             TransactionID: paymentTransID,
  //           })
  //         );
  //         if (
  //           deleteRelationData.data
  //             .deleteTransactionRelationByObjectAttribute != null
  //         ) {
  //           saveCurrentLinkPayment(invID, paymentTransID);
  //         }
  //         const updateTimeStamp = {
  //           TransactionID: paymentTransID,
  //           EnteredTimeStamp: Math.floor(
  //             new Date(data.invoiceDate).getTime() / 1000
  //           ),
  //         };
  //         const resUpdateTimeStamp = await API.graphql(
  //           graphqlOperation(updatetransactionTimeStamp, updateTimeStamp)
  //         );
  //       } else {
  //         savePaymentDetails(invID);
  //       }
  //     } else {
  //       if (paymentTransID !== "" && data?.paymentDeletionFlag === true) {
  //         const deleteTransMaster = await API.graphql(
  //           graphqlOperation(deleteTransactionMaster, {
  //             TransactionID: paymentTransID,
  //           })
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }
  async function updatePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let linkedArr = [];
      if (data.paymentType !== "Credit") {
        if (paymentTransID !== "") {
          const transMaster = {
            transactionid: paymentTransID,
            bankreferencenumber: data.bankReferenceNo,
            entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
            comments: "",
            vouchernumber: data.transactionVoucher,
            serialnumber: data.transactionSeries.value,
            transactiontypecd:
              data.paymentType == "Cash"
                ? "CashReceipt"
                : data.paymentType == "Bank"
                ? "BankReceipt"
                : "Credit",
          };

          paymentTransArr.map((ele, index) => {
            const paymentTransDetails = {
              accountid: ele.accID,
              comments: data.remarks,
              creditamount: Number(ele.creditAmt),
              debitamount: Number(ele.debitAmt),
              entryordernumber: index + 1,
              transactionid: paymentTransID,
              transactiontypecd: ele.debitAmt !== 0 ? "Debit" : "Credit",
              enteredtimestamp: Math.floor(
                new Date(data.invoiceDate).getTime() / 1000
              ),
            };
            tranSDetailsArr.push(paymentTransDetails);
          });

          const linkCurrentPayment = {
            linkedamount: Number(data.receivedAmount),
            transactiontypecd: "PosInvoice",
            isdirect: 1,
            objectattribute: data.voucherNumber,
            objectid: invoiceEntry?.invoiceid,
            objecttype: data.paymentType,
            transactionid: paymentTransID,
            accountid: partyAccountID === "" ? 0 : partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
          };
          linkedArr.push(linkCurrentPayment);
          linkedTransArr.map(async (ele) => {
            let linkTransData = {
              linkedamount: Number(ele.linkedamount),
              transactiontypecd: "PosInvoice",
              isdirect: 0,
              objectattribute: data?.voucherNumber,
              objectid: invID,
              objecttype: ele.transactiontypecd,
              transactionid: ele.transactionid,
              accountid: partyAccountID === "" ? 0 : partyAccountID,
              paymentvouchernumber: data?.transactionVoucher,
            };
            linkedArr.push(linkTransData);
          });

          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTime, {
              transactionmaster: JSON.stringify([transMaster]),
              transactiondetails: JSON.stringify(tranSDetailsArr),
              transactionattachment: JSON.stringify([]),
              transactiontdsdetails: JSON.stringify([]),
              transactionrelation: JSON.stringify(linkedArr),
              mode: 0,
              transactiontcsdetails: JSON.stringify([]),
            })
          );
        } else {
          savePaymentDetails(invID);
        }
      } else {
        if (paymentTransID !== "" && data?.paymentDeletionFlag === true) {
          const deleteTransMaster = await API.graphql(
            graphqlOperation(deleteTransactionMaster, {
              transactionid: paymentTransID,
            })
          );
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);

        element?.focus();
      }
    }
  }, [errorArr]);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);

      element?.focus();
    }
  }, [tableErrArr]);
  useEffect(() => {
    let id = "partyContactNumber";
    if (params?.id) {
      getInvoiceMasterData(params?.id);
      setViewMode(params?.view);
    }
    let element = document?.getElementById(id);
    element?.focus();
  }, []);

  const [promptInvoiceSetting, setpromptInvoiceSetting] = useState(false);
  const { updated } = location.state || {};
  async function getLastSalesInvoice() {
    try {
      const res = await API.graphql(graphqlOperation(listlatestInvoiceCustom));
      console.log(res.data);
      if (res?.data?.listlatestInvoice?.length > 0) {
        let momentLastInvoiceDate = moment(
          res?.data?.listlatestInvoice?.[0]?.invoicedate * 1000
        ).format("YYYY-MM-DD");
        setLastInvoiceDate(momentLastInvoiceDate);
      } else {
        if (InvoiceSettings?.defaultsetting == 1) setpromptInvoiceSetting(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  async function print(htmlOnly) {
    let html = await PosPrint({
      data,
      items,
      netAmountToPay,
      totGstCess: totGSTCess,
      totDiscount: totDiscount,
      totGST,
      totNetAmount: netAmountToPay,
      registrationType,
      totAmount: totAmt,
      companyDetails: companyData,
      InvoiceSettings,
      companyState: companyState,
    });
    if (htmlOnly) {
      return html;
    } else {
      printJS({
        printable: html,
        type: "raw-html",
        documentTitle: "",
      });
    }
  }
  useEffect(() => {
    getLastSalesInvoice();
  }, []);

  const MailIt = async (InvoiceName) => {
    let html = await print(true);

    try {
      const option = {
        method: "POST",
        url: "https://hotk5j6lmqvviyjqc5jp7y7qh40yczuu.lambda-url.ap-south-1.on.aws/",
        data: JSON.stringify({ html, InvoiceName }),
      };
      return await axios(option);
    } catch (error) {
      console.log(error);
    }
  };
  const callBackNavigate = () => navigate("/allpos");
  
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          saveEditChanges();
        }
      : params?.view !== true
      ? () => saveChanges({ new: false })
      : undefined
  );
  return (
    <Box
      className="PageHeight"
      // sx={{
      //   padding:
      //     isVoucher === true
      //       ? { xs: "20px 20px 20px 20px", sm: "30px 30px 0px 30px" }
      //       : { xs: "80px 20px 20px 20px", sm: "70px 30px 20px 80px" },
      //   m: 1,
      // }}
    >
      {/* {viewMode === true && backdropOpen == false && (
        <Box
          sx={{
            position: "sticky", // Make the box sticky
            top: "10px", // Adjust the distance from the top as needed
            // backgroundColor: "white", // Set a background color
            borderRadius: "8px",
            marginBottom: "0px",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            transition: "all 1s ease-in-out",
            zIndex: 1100, // Ensure the box stays above other content
          }}
        >
          <Alert
            variant="standard"
            sx={{
              color: invoiceEntry.CancelFlag === 0 ? "" : "red",
              boxShadow: "none",
              width: 400,
              zIndex: 1000,
            }}
            severity={invoiceEntry.CancelFlag === 0 ? "info" : "error"}
          >
            {invoiceEntry.CancelFlag === 0
              ? ` Fields are disabled. To make changes${" "}`
              : "Invoice cancelled. No further updates can be made."}
            {invoiceEntry.CancelFlag === 0 ? (
              <Link
                id="EnableEdit"
                underline="hover"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  if (Freeze == 1) {
                    return handleFreeze()
                  }
                  navigate("/editpos", {
                    state: { id: invoiceEntry?.InvoiceID },
                  });
                }}
              >
                Enable Edit
                <EditIcon sx={{ fontSize: "14px" }} />
              </Link>
            ) : null}
          </Alert>
        </Box>
      )} */}

      {viewMode === true && invoiceEntry.cancelflag ? (
        <Box
          sx={{
            position: "sticky", // Make the box sticky
            top: "10px", // Adjust the distance from the top as needed
            // backgroundColor: "white", // Set a background color
            borderRadius: "8px",
            marginBottom: "0px",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            transition: "all 1s ease-in-out",
            // zIndex: 1100, // Ensure the box stays above other content
          }}
        >
          <Alert
            variant="standard"
            sx={{
              color: "red",
              boxShadow: "none",
              width: 450,
              // zIndex: 1000,
            }}
            severity={"error"}
          >
            {invoiceEntry.cancelflag === 1
              ? "POS Invoice cancelled. No further updates can be made."
              : null}
          </Alert>
        </Box>
      ) : null}

      <Paper
        className={viewMode == true ? "disable-interactions" : ""}
        sx={{
          borderRadius: "8px",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <InvoicePosBasicDetails
          data={data}
          setData={setData}
          setInitialState={setInitialState}
          todayDate={todayDate}
          moment={moment}
          endDayDate={endDayDate}
          setEndDayDate={setEndDayDate}
          invoiceLabels={{
            partyName: "Customer Name",
            gstINName: "Customer GSTIN",
            seriesName: "Invoice Series Name",
            voucherName: "Invoice Number",
            voucherValue: "voucherNumber",
            dateName: "Invoice Date",
            seriesValue: "seriesVouchers",
            voucherType: "PosInvoice",
            orderNumberName: "Customer Order Number",
            voucherModalName: "Pos Invoice Number Settings",
            orderDateName: "Customer Order Date",
          }}
          fromDayDate={fromDayDate}
          setFromDayDate={setFromDayDate}
          partyTypeCD={"CUSTOMER"}
          params={params}
          voucherArr={voucherArr}
          setVoucherArr={setVoucherArr}
          companyState={companyState}
          setCompanyState={setCompanyState}
          setCompanyData={setCompanyData}
          Type="Pos"
          companyData={companyData}
          deliveryAddressDetails={deliveryAddressDetails}
          setDeliveryAddressDetails={setDeliveryAddressDetails}
          billingAddressDetails={billingAddressDetails}
          partyDeliveryAddressEntity={partyDeliveryAddressEntity}
          setPartyDeliveryAddressEntity={setPartyDeliveryAddressEntity}
          setBillingAddressDetails={setBillingAddressDetails}
          partyBillAddressEntity={partyBillAddressEntity}
          setPartyBillAddressEntity={setPartyBillAddressEntity}
          showWarningSnackbar={showWarningSnackbar}
          showSuccessSnackbar={showSuccessSnackbar}
          setPartyNameOptions={setPartyNameOptions}
          partyNameOptions={partyNameOptions}
          invoiceEntry={invoiceEntry}
          partyAccountID={partyAccountID}
          setPartyAccountID={setPartyAccountID}
          lastInvoiceDate={lastInvoiceDate}
          items={items}
          setItems={setItems}
          accNames={accNames}
          unitsObj={unitsObj}
          setRegistrationType={setRegistrationType}
          registrationType={registrationType}
          setBackdropOpen={setBackdropOpen}
          partyType={partyType}
          setPartyType={setPartyType}
          itemCodes={itemCodes}
          setItemCodes={setItemCodes}
          itemNames={itemNames}
          setItemNames={setItemNames}
          totNetAmt={totNetAmt}
        />
      </Paper>
      <Paper
        sx={{
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
          ".MuiTableCell-root": {
            padding: "0px 5px",
          },
          ".MuiTableCell-head": {
            borderBottom: "0px",
            fontWeight: "bold",
          },
        }}
      >
        <Box sx={{ m: 2 }}>
          <EntryTable
            setInitItemTableDta={setInitItemTableDta}
            data={data}
            setInitialState={setInitialState}
            setData={setData}
            totTaxAmt={totTaxAmt}
            setTotTaxAmt={setTotTaxAmt}
            totDiscount={totDiscount}
            setTotDicount={setTotDicount}
            totGSTCess={totGSTCess}
            setTotGSTCess={setTotGSTCess}
            totNetAmt={totNetAmt}
            setTotNetAmt={setTotNetAmt}
            totGST={totGST}
            setTotGST={setTotGST}
            totAmt={totAmt}
            setTotAmt={setTotAmt}
            accNames={accNames}
            setAccNames={setAccNames}
            items={items}
            setItems={setItems}
            nonItems={nonItems}
            setNonItems={setNonItems}
            nonItemEditedRow={nonItemEditedRow}
            setNonItemEditedRow={setNonItemEditedRow}
            nonItemTempRow={nonItemTempRow}
            setNonItemTempRow={setNonItemTempRow}
            companyState={companyState}
            setItemID={setItemID}
            itemID={itemID}
            itemType={itemType}
            setItemType={setItemType}
            openAddItemModal={openAddItemModal}
            setOpenAddItemModal={setOpenAddItemModal}
            Type="Pos"
            invoiceEntry={invoiceEntry}
            setDisplayAllAccounts={setDisplayAllAccounts}
            displayAllAccounts={displayAllAccounts}
            expenceAccNames={expenceAccNames}
            units={units}
            setunits={setunits}
            setExpenceAccNames={setExpenceAccNames}
            unitsObj={unitsObj}
            setUnitsObj={setUnitsObj}
            companyData={companyData}
            registrationType={registrationType}
            setBackdropOpen={setBackdropOpen}
            viewMode={viewMode}
            setItemValid={setItemValid}
            itemValid={itemValid}
            nonItemValid={nonItemValid}
            setNonItemValid={setNonItemValid}
            partyType={partyType}
            setPartyType={setPartyType}
            isFocusItemRow={isFocusItemRow}
            isFocusNonItemRow={isFocusNonItemRow}
            setIsNonItemFocusRow={setIsNonItemFocusRow}
            setIsFocusItemRow={setIsFocusItemRow}
            setTableErrArr={setTableErrArr}
            setDeletedItems={setDeletedItems}
            itemCodes={itemCodes}
            setItemCodes={setItemCodes}
            itemNames={itemNames}
            setItemNames={setItemNames}
            netAmountToPay={netAmountToPay}
            invoiceLabels={{
              partyName: "Customer Name",
              gstINName: "Customer GSTIN",
              seriesName: "Invoice Series Name",
              voucherName: "Invoice Number",
              voucherValue: "voucherNumber",
              dateName: "Invoice Date",
              seriesValue: "seriesVouchers",
              voucherType: "PosInvoice",
              orderNumberName: "Customer Order Number",
              voucherModalName: "Pos Invoice Number Settings",
              orderDateName: "Customer Order Date",
            }}
            labelNamesOfTcs={{
              tdsOrTcsType: "2",
              amountName: "Invoice Amount",
              tcsOrTdsName: "Add TCS if any",
              tcsOrTdsLabel: "TCS Section",
              tcsOrTdsAmountLabel: "TCS (%)",
              amountAfterLabel: "Amount(After TCS)",
            }}
            labelNamesOfTds={{
              tdsOrTcsType: "1",
              amountName: "Invoice Amount",
              tcsOrTdsName: "Add TDS if any",
              tcsOrTdsLabel: "TDS Section",
              tcsOrTdsAmountLabel: "TDS (%)",
              amountAfterLabel: "Amount(After TDS)",
            }}
          />
        </Box>
      </Paper>
      <Paper
        sx={{
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
          ".MuiTableCell-root": {
            padding: "4px 10px",
          },
          ".MuiTableCell-head": {
            backgroundColor: "background.tablebg",
            padding: "10px 8px",
            borderBottom: "0px",
            fontSize: "13px",
            fontWeight: "bold",
          },
        }}
      >
        <Box
          sx={{
            m: 1,
            display: "flex",
            flexWrap: { xs: "wrap", md: "wrap" },
            flexDirection: { xs: "column", lg: "row" },
          }}
        >
          <HsnandJournalTab
            data={data}
            setData={setData}
            companyState={companyState}
            items={items}
            nonItems={nonItems}
            totTaxAmt={totTaxAmt}
            totNetAmt={totNetAmt}
            totGST={totGST}
            Type="Pos"
            setInvTransArr={setInvTransArr}
            invTransArr={invTransArr}
            paymentTransArr={paymentTransArr}
            setPaymentTransArr={setPaymentTransArr}
            setItems={setItems}
            setNonItems={setNonItems}
            nonItemEditedRow={nonItemEditedRow}
            setNonItemEditedRow={setNonItemEditedRow}
            nonItemTempRow={nonItemTempRow}
            setNonItemTempRow={setNonItemTempRow}
            tcsOptionValue={tcsOptionValue}
            setTcsoptionValue={setTcsoptionValue}
            setTotTaxAmt={setTotTaxAmt}
            totDiscount={totDiscount}
            setTotDicount={setTotDicount}
            totGSTCess={totGSTCess}
            setTotGSTCess={setTotGSTCess}
            setTotNetAmt={setTotNetAmt}
            setTotGST={setTotGST}
            totAmt={totAmt}
            setTotAmt={setTotAmt}
            accNames={accNames}
            setNetAmountToPay={setNetAmountToPay}
            netAmountToPay={netAmountToPay}
            amountAfterDiscount={amountAfterDiscount}
            setAmountAfterDiscount={setAmountAfterDiscount}
            amountAfterTCS={amountAfterTCS}
            setAmountAfterTCS={setAmountAfterTCS}
            registrationType={registrationType}
            tabvalue={tabvalue}
            setTabValue={setTabValue}
            partyType={partyType}
            setPartyType={setPartyType}
          />
          <Paper
            className={viewMode == true ? "disable-interactions" : ""}
            sx={{
              flex: { xs: 1, lg: 0.5 },
              m: "5px",
              border: "1px solid #C9C9C9",
              borderColor: "input.label",
              height: 290,
              p: "5px",
              overflowX: "none",
            }}
          >
            <TotalAmountLabels
              setInitialState={setInitialState}
              data={data}
              setData={setData}
              setTcsSections={setTcsSections}
              tcsSections={tcsSections}
              tdsSections={tdsSections}
              setTdsSections={setTdsSections}
              tcsOptionValue={tcsOptionValue}
              setTcsoptionValue={setTcsoptionValue}
              tdsOptionValue={tdsOptionValue}
              setTdsoptionValue={setTdsoptionValue}
              totTaxAmt={totTaxAmt}
              setTotTaxAmt={setTotTaxAmt}
              totDiscount={totDiscount}
              setTotDicount={setTotDicount}
              totGSTCess={totGSTCess}
              setTotGSTCess={setTotGSTCess}
              totNetAmt={totNetAmt}
              setTotNetAmt={setTotNetAmt}
              totGST={totGST}
              setTotGST={setTotGST}
              totAmt={totAmt}
              setTotAmt={setTotAmt}
              labelNamesOfTcs={{
                tdsOrTcsType: "2",
                amountName: "Invoice Amount",
                tcsOrTdsName: "Add TCS if any",
                tcsOrTdsLabel: "TCS Section",
                tcsOrTdsAmountLabel: "TCS (%)",
                amountAfterLabel: "Amount(After TCS)",
              }}
              labelNamesOfTds={{
                tdsOrTcsType: "1",
                amountName: "Invoice Amount",
                tcsOrTdsName: "Add TDS if any",
                tcsOrTdsLabel: "TDS Section",
                tcsOrTdsAmountLabel: "TDS (%)",
                amountAfterLabel: "Amount(After TDS)",
              }}
              setNetAmountToPay={setNetAmountToPay}
              netAmountToPay={netAmountToPay}
              amountAfterDiscount={amountAfterDiscount}
              setAmountAfterDiscount={setAmountAfterDiscount}
              amountAfterTCS={amountAfterTCS}
              setAmountAfterTCS={setAmountAfterTCS}
              setAmountAfterTDS={setAmountAfterTDS}
              amountAfterTDS={amountAfterTDS}
              Type="Pos"
              invoiceEntry={invoiceEntry}
              partyAccountID={partyAccountID}
              setLinkedTransArr={setLinkedTransArr}
              showWarningSnackbar={showWarningSnackbar}
              Enable_ItemWiseEntry={Enable_ItemWiseEntry}
              registrationType={registrationType}
              partyType={"CUSTOMER"}
            />
          </Paper>
        </Box>
      </Paper>
      <Paper
        className={viewMode == true ? "disable-interactions" : ""}
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <PaymentDetails
          Enable_CreditPeriod={Enable_CreditPeriod}
          data={data}
          setData={setData}
          setInitialState={setInitialState}
          paymentAccordion={paymentAccordion}
          setPaymentAccordion={setPaymentAccordion}
          todayDate={todayDate}
          moment={moment}
          creditPeriod={creditPeriod}
          companyData={companyData}
          setCompanyData={setCompanyData}
          accNames={accNames}
          setExpenceAccNames={setExpenceAccNames}
          setAccNames={setAccNames}
          paymentType={"Receipt Details"}
          paymentLabels={{
            seriesName: "Receipt Series Name",
            voucherName:
              data.paymentType == "Cash"
                ? "Cash Receipt Number"
                : "Bank Receipt Number",
            voucherValue: "transactionVoucher",
            seriesValue: "transactionSeries",
            voucherType: "Receipt",
            accLabel: "Received To Account (Dr)",
            accNames: "Received To Account",
            amountName: "Received Amount",
            dueDateName: "Invoice Due Date",
            voucherModalName: "Receipt Number Settings",
          }}
          totNetAmt={totNetAmt}
          netAmountToPay={netAmountToPay}
          setTransGeneralSettingsFlag={setTransGeneralSettingsFlag}
          transGeneralSettingsFlag={transGeneralSettingsFlag}
          setTotNetAmt={setTotNetAmt}
          Type="Pos"
          invoiceEntry={invoiceEntry}
          setTransVoucherArr={setTransVoucherArr}
          transVoucherArr={transVoucherArr}
          setPaymentTransID={setPaymentTransID}
          paymentTransID={paymentTransID}
          setCurrentVoucherNo={setCurrentVoucherNo}
          currentVoucherNo={currentVoucherNo}
          showWarningSnackbar={showWarningSnackbar}
          showSuccessSnackbar={showSuccessSnackbar}
          partyAccountID={partyAccountID}
          partyNameOptions={partyNameOptions}
          params={params}
          partyType={partyType}
        />
      </Paper>
      <Paper
        className={viewMode === true ? "disable-interactions" : ""}
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Grid container spacing={1}>
          <Grid
            item
            lg={3}
            xs={12}
            md={12}
            sx={{
              ".MuiPaper-root": {
                boxShadow: "none",
              },
            }}
          >
            <Description
              labelName="Invoice Description"
              data={data}
              setData={setData}
              setInitialState={setInitialState}
              Type="Sales"
              invoiceEntry={invoiceEntry}
            />
          </Grid>
          <Grid item lg={9} xs={12} md={12}>
            <MultiFileAttachment
              data={data}
              itemsRows={itemsRows}
              setItemsRows={setItemsRows}
              setInitialAttachments={setInitialAttachments}
              Type="Pos"
              invoiceEntry={invoiceEntry}
              showWarningSnackbar={showWarningSnackbar}
              viewMode={viewMode}
              setCurrentDocuments={setCurrentDocuments}
            />
          </Grid>
        </Grid>
      </Paper>
      {/* 
      <FloatingButton
        setCancelModal={setCancelModal}
        saveChanges={() => {
          saveChanges({ new: false });
        }}
        saveChangesPrint={() => {
          saveChanges({ print: true, preview: false });
          // handlePrint(state.vouchernumber)
        }}
        saveEditChanges={() => saveEditChanges()}
        saveandNew={() => saveChanges({ new: true })}
        saveChangesFlag={true}
        isModal={false}
        setPreviewModal={setPreviewSalesTaxableModal}
        previewLabel="Preview Invoice"
        printButton={true}
        paramsID={params?.id}
        paramsView={params?.view}
        onPrint={print}
      /> */}
      {/* {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? (
        <DraggableAction
          actionType={params?.id && params?.view !== true ? "edit" : "save"}
          from={"POS"}
          onExit={() => {
            setCancelModal(true);
          }}
          onSave={
            params?.id && params?.view !== true
              ? () => {
                  saveEditChanges();
                }
              : params?.view !== true
              ? () => saveChanges({ new: false })
              : null
          }
          onEnableEdit={() => {
            navigate("/editpos", {
              state: { id: invoiceEntry?.invoiceid },
            });
          }}
          onPrint={params?.view == true || params?.id ? () => print() : null}
          onCancel={
            params?.view == true || params?.id
              ? () => {
                  setCancelModalStatus(true);
                  // setItemData({ id: invoiceEntry?.InvoiceID })
                  setItemData({
                    id: invoiceEntry?.invoiceid,
                    CancelFlag: invoiceEntry?.cancelflag,
                    invoicetype: invoiceEntry?.invoicetaxabletypecd,
                    nav: "/allpos",
                    todo: "cancel",
                    linked: paymentTransID !== "",
                    from: "POS Invoice",
                  });
                }
              : null
          }
          onDelete={
            params?.view == true || params?.id
              ? () => {
                  setDeleteModalStatus(true);
                  setItemData({
                    id: invoiceEntry?.invoiceid,
                    nav: "/allpos",
                    todo: "delete",
                    linked: paymentTransID !== "",
                    from: "POS Invoice",
                  });
                }
              : null
          }
          onPreview={
            params?.view == true || Number.isNaN(params?.id)
              ? () => {
                  setPreviewSalesTaxableModal(true);
                }
              : null
          }
          onSaveNew={
            params?.view !== true ? () => saveChanges({ new: true }) : null
          }
          onReset={
            params?.view !== true
              ? () => {
                  if (params?.id) {
                    setItems(initItemTableDta);

                    setData(initialState);
                  } else {
                    setData(initialState);
                    let obj2 = {
                      itemCode: { label: "", value: "" },
                      name: { label: "", value: "" },
                      priceType: { label: "", value: "" },
                      ledgerAccount: { label: "", value: "" },
                      HSN: {
                        label: "",
                        value: "",
                        companyID: "",
                        hsnID: "",
                        codeType: "",
                        description: "",
                      },
                      qty: 0,
                      units: "",
                      rate: 0,
                      amount: 0,
                      dicount: 0,
                      taxableAMount: 0,
                      GSTRate: "",
                      taxability: { label: "", value: "" },
                      manualDiscount: false,
                      manualCess: false,
                      IGST: 0,
                      expiredtimestamp: 0,
                      CGST: "0.00",
                      SGST: "0.00",
                      GSTCess: 0,
                      netAmount: "0000",
                      editable: true,
                      new: true,
                    };
                    setItems([obj2]);
                  }
                }
              : null
          }
        />
      ) : null} */}
      {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? (
        <DraggableAction
          actionType={params?.id && params?.view !== true ? "edit" : "save"}
          from={"POS Invoice"}
          onExit={() => {
            setCancelModal(true);
          }}
          onSave={
            params?.id && params?.view !== true
              ? () => {
                  saveEditChanges();
                }
              : params?.view !== true
              ? () => saveChanges({ new: false })
              : null
          }
          onEnableEdit={() => {
            navigate("/editpos", {
              state: { id: invoiceEntry?.invoiceid },
            });
          }}
          onPrint={params?.view == true || params?.id ? () => print() : null}
          onCancel={
            params?.view == true || params?.id
              ? () => {
                  setCancelModalStatus(true);
                  setItemData({
                    id: invoiceEntry?.invoiceid,
                    nav: "/allpos",
                    todo: "cancel",
                    linked: paymentTransID !== "",

                    from: "POS Invoice",
                  });
                }
              : null
          }
          onDelete={
            params?.view == true || params?.id
              ? () => {
                  setDeleteModalStatus(true);
                  setItemData({
                    id: invoiceEntry?.invoiceid,
                    nav: "/allpos",
                    todo: "delete",
                    linked: paymentTransID !== "",
                    // fn: () => deletePurchaseInvoice(invoiceEntry?.PurchaseID),
                    from: "POS Invoice",
                  });
                }
              : null
          }
          onPreview={
            params?.view == true || Number.isNaN(params?.id)
              ? () => {
                  setPreviewSalesTaxableModal(true);
                }
              : null
          }
          onSaveNew={
            params?.view !== true ? () => saveChanges({ new: true }) : null
          }
          onReset={
            params?.view !== true
              ? () => {
                  if (params?.id) {
                    setItems(initItemTableDta);

                    setData(initialState);
                  } else {
                    setData(initialState);
                    let obj1 = {
                      ledgerAccount: { label: "", value: "" },
                      HSN: {
                        label: "",
                        value: "",
                        companyID: "",
                        hsnID: "",
                        codeType: "",
                        description: "",
                      },
                      description: "",
                      taxableAMount: 0,
                      GSTRate: "",
                      taxability: { label: "", value: "" },
                      manualDiscount: false,
                      manualCess: false,
                      IGST: 0,
                      expiredtimestamp: 0,
                      CGST: "0.00",
                      SGST: "0.00",
                      GSTCess: 0,
                      netAmount: 0,
                      editable: true,
                      new: true,
                    };
                    setNonItems([obj1]);

                    let obj2 = {
                      itemCode: { label: "", value: "" },
                      name: { label: "", value: "" },
                      priceType: { label: "", value: "" },
                      ledgerAccount: { label: "", value: "" },
                      HSN: {
                        label: "",
                        value: "",
                        companyID: "",
                        hsnID: "",
                        codeType: "",
                        description: "",
                      },
                      qty: 0,
                      units: "",
                      rate: 0,
                      amount: 0,
                      dicount: 0,
                      taxableAMount: 0,
                      GSTRate: "",
                      taxability: { label: "", value: "" },
                      manualDiscount: false,
                      manualCess: false,
                      IGST: 0,
                      expiredtimestamp: 0,
                      CGST: "0.00",
                      SGST: "0.00",
                      GSTCess: 0,
                      netAmount: "0000",
                      editable: true,
                      new: true,
                    };
                    setItems([obj2]);
                  }
                }
              : null
          }
        />
      ) : null}
      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={"Cancel"}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          netAmountToPay={netAmountToPay}
          companyState={companyState}
          Type={"Pos"}
        />
      ) : null}
      {deleteModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteModalStatus}
          setOpen={setDeleteModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          actionType={"Delete"}
          Type={"Pos"}
        />
      ) : null}
      <ConfirmCancel
        open={cancelModal}
        setOpen={setCancelModal}
        path="allpos"
      />
      <Loader open={backdropOpen} />
      <PreviewSalesTaxable
        open={previewSalesTaxableModal}
        setOpen={setPreviewSalesTaxableModal}
        getHtml={print}
      />
      <PromptInvoiceSettings
        open={promptInvoiceSetting}
        onClick={() => {
          navigate("/invoiceSettings", {
            state: { title: "newpos" },
          });
        }}
        onClose={() => setpromptInvoiceSetting(false)}
      />
      {modalOpen && (
        <ConfirmExit
          open={modalOpen}
          setOpen={setModalOpen}
          reNavigate={reNavigate}
        />
      )}
    </Box>
  );
}

export default NewPos;
